<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Képviselői kihelyezések</span>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="representativePlacement/fetchAll"
      />
    </div>
    <representative-placement-list />
  </el-card>
</template>

<script>
  import RepresentativePlacementList from '../../components/representativeProcesses/representativePlacements/List';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      RepresentativePlacementList,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let storages = this.$store.getters['storage/storages'];
        let users = this.$store.getters['user/users'];
        if (!storages.length) {
          await this.$store.dispatch('storage/fetchAll');
          storages = this.$store.getters['storage/storages'];
        }
        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        this.filterConfig = [
          {
            type: 'text',
            name: 'receipt_number',
            label: 'Bizonylatszám',
            defaultSearch: true,
          },
          {
            type: 'select',
            options: [
              {
                label: 'Teljesített',
                status: 'done'
              },
              {
                label: 'Kihelyezve',
                status: 'lent'
              },
              {
                label: 'Rögzítve',
                status: 'recorded'
              },
              {
                label: 'Lemondva',
                status: 'cancelled'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Normál',
                status: 'normal'
              },
              {
                label: 'Promóciós',
                status: 'promotion'
              },
              {
                label: 'POS',
                status: 'pos'
              },
            ],
            name: 'category',
            label: 'Kategória',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'multipleSelect',
            options: storages,
            name: 'storage',
            label: 'Raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
          },
          {
            type: 'multipleSelect',
            options: users,
            name: 'representativeUser',
            label: 'Képviselő',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
          {
            type: 'multipleRemoteSelect',
            name: 'customer_id',
            label: 'Vevő',
            labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
            valueKey: 'id',
            remoteSearchParam: 'name',
            remoteAction: 'partner/search',
          },
          {
            type: 'multipleRemoteSelect',
            name: 'shop_id',
            label: 'Üzlet',
            labelCallback: shop => shop && `#${shop.id} ${shop.name}` || '',
            valueKey: 'id',
            remoteSearchParam: 'name',
            remoteAction: 'shop/search',
          },
        ];
      },
    },
  };
</script>
